import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import MuiTypography from 'components/@mui-extend/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { Loader } from 'components'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { generateRandomKey } from 'utils'
import { validPublishedStatuses, onReviewStatuses, userRoles } from 'config/constants'

const style = makeStyles(theme => ({
  label: {
    fontSize: 12,
  },
  visibleLabel: {
    color: theme.palette.success.main,
  },
  unVisibleLabel: {
    color: theme.palette.gray[3],
  },
  visibleIcon: {
    fill: theme.palette.success.main,
    marginRight: theme.spacing(2),
  },
  noVisibleIcon: {
    fill: `#BFBEBF`,
    marginRight: theme.spacing(2),
  },
  cellWithLink: {
    cursor: `pointer`,
  },
  tooltip: {
    background: `rgba(0, 0, 0, 0.7)`,
    padding: theme.spacing(0.5, 1),
    borderRadius: 5,
    color: theme.palette.primary.light,
  },
  publishedRow: {
    background: theme.palette.primary.light,
  },
  noPublished: {
    background: `#FBFBFB`,
  },
  toReview: {
    border: `1px solid #007BFF26`,
    background: `#007BFF26`,
  },
  emptyExpe: {
    textAlign: `center`,
    width: `100%`,
    padding: theme.spacing(4, 0),
    fontSize: theme.fontSize[2],
    fontWeight: theme.fontWeight[3],
  },
  textSection: {
    color: `#7F8FA4 !important`,
  },
  expTitle: {
    textTransform: `capitalize`,
  },
}))

export default function ExperienceTableWrapper({
  loading = true,
  tableCells = [],
  tableBody = [],
  onExperienceAction = () => {},
  role,
}) {
  const { push: pushHistory } = useHistory()
  const classes = style()

  function renderTableHeader() {
    return (
      <TableHead>
        <TableRow>
          {tableCells.map(tableCell => {
            const { dataIndex, label, align, width = undefined } = tableCell
            return (
              <TableCell
                key={generateRandomKey(`table-cell`, dataIndex)}
                align={align}
                style={{ width: width ? width : `auto` }}
                size="small"
              >
                <MuiTypography title={label} size={12} weight="bold" />
              </TableCell>
            )
          })}
        </TableRow>
      </TableHead>
    )
  }

  function renderTableBody() {
    if (tableBody.length === 0) {
      return (
        <TableBody>
          <TableRow>
            <TableCell size="small" align="center">
              <Typography variant="h3" align="center">
                !No Existen Experiencias, crea la primera!
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      )
    }
    return (
      <TableBody>
        {tableBody.map(row => {
          const published_row = validPublishedStatuses.includes(row.experiences_status_id)
          return (
            <Fragment key={generateRandomKey(`table-box`, row.id)}>
              {row.section && row.section.id === row.id && (
                <TableRow key={generateRandomKey(`table-row-section`, row.id)}>
                  <TableCell
                    key={generateRandomKey(`table-row-cell-section`, row.id)}
                    size="small"
                    colSpan={6}
                  >
                    <MuiTypography title={row.section.title} size={12} weight="bold" />
                  </TableCell>
                </TableRow>
              )}
              <TableRow
                key={generateRandomKey(`table-row`, row.id)}
                className={
                  onReviewStatuses.includes(row.experiences_status_id) &&
                  role !== userRoles.Provider
                    ? classes.toReview
                    : published_row
                    ? classes.publishedRow
                    : classes.noPublished
                }
              >
                {tableCells.map(tableCell => renderCell({ tableCell, row, published_row }))}
              </TableRow>
            </Fragment>
          )
        })}
      </TableBody>
    )
  }

  function renderCell({ tableCell, row, published_row }) {
    const {
      align,
      width,
      dataIndex,
      link = null,
      tooltip: { validStatus = null, text = `` } = {},
      ...cellRest
    } = tableCell
    const showTooltip = validStatus ? validStatus.includes(row.experiences_status_id) : false
    if (showTooltip) {
      return (
        <Tooltip
          title={<Typography className={classes.tooltip}>{text}</Typography>}
          placement="top-start"
        >
          <TableCell
            key={generateRandomKey(`table-row-cell`, `${dataIndex}-${row.id}`)}
            align={align}
            style={{ width: width ? width : `auto` }}
            size="small"
            className={link ? classes.cellWithLink : ``}
            onClick={() => (link ? pushHistory(`${link}${row.id}`) : null)}
          >
            {renderCellContent({ ...cellRest, row, published_row, dataIndex })}
          </TableCell>
        </Tooltip>
      )
    }
    return (
      <TableCell
        key={generateRandomKey(`table-row-cell`, `${dataIndex}-${row.id}`)}
        align={align}
        style={{ width: width ? width : `auto` }}
        size="small"
        className={link ? classes.cellWithLink : ``}
        onClick={() => (link ? pushHistory(`${link}${row.id}`) : null)}
      >
        {renderCellContent({ ...cellRest, row, published_row, dataIndex })}
      </TableCell>
    )
  }

  function renderCellContent({
    sendFullExperience,
    sendActionListerner = false,
    extraClass = ``,
    component = null,
    readFunction = null,
    withEyeIndicator,
    row,
    published_row,
    dataIndex,
  }) {
    const cellValue = readFunction ? readFunction(row[dataIndex]) : row[dataIndex]
    return (
      <>
        {component ? (
          <Grid container justify="center">
            {component(
              sendFullExperience
                ? {
                    ...row,
                    ...(sendActionListerner && {
                      onChange: onExperienceAction,
                    }),
                  }
                : cellValue,
            )}
          </Grid>
        ) : withEyeIndicator ? (
          <Grid container alignItems="center">
            <Grid item md={1}>
              {renderEyeIndicator(published_row)}
            </Grid>
            <Grid item md={11}>
              <Typography
                component="p"
                className={`${published_row ? classes.visibleLabel : classes.unVisibleLabel} ${
                  classes[extraClass]
                } ${classes.label}`}
              >
                {cellValue}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Typography
            component="p"
            className={`${published_row ? classes.visibleLabel : classes.unVisibleLabel} ${
              classes[extraClass]
            } ${classes.label}`}
          >
            {cellValue}
          </Typography>
        )}
      </>
    )
  }

  function renderEyeIndicator(published_row) {
    return (
      <>
        {published_row ? (
          <Tooltip
            title={
              <Typography className={classes.tooltip}>
                Esta experiencia se encuentra publicada{` `}
              </Typography>
            }
            placement="top"
          >
            <Visibility className={classes.visibleIcon} />
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <Typography className={classes.tooltip}>
                Esta experiencia No se encuentra publicada.
              </Typography>
            }
            placement="top"
          >
            <VisibilityOff className={classes.noVisibleIcon} />
          </Tooltip>
        )}
      </>
    )
  }

  return (
    <TableContainer component={Paper}>
      <Table stickyHeader size="small">
        {renderTableHeader()}
        {!loading && renderTableBody()}
      </Table>
      {loading && <Loader />}
    </TableContainer>
  )
}
